var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSbpLogo = function SvgIconSbpLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.74756L3.7541 13.4578V17.5508L0.00439166 24.2478L0 6.74756Z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.415 11.0163L17.9328 8.86023L25.132 8.85352L14.415 15.4188V11.0163Z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3944 6.70813L14.4142 15.5922L10.6514 13.2801V0L14.3946 6.70813H14.3944Z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1312 8.85333L17.9317 8.86005L14.3944 6.70813L10.6514 0L25.1309 8.85333H25.1312Z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4142 24.285V19.9747L10.6514 17.7065L10.6534 30.9998L14.4142 24.285Z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9231 22.1486L3.75384 13.4578L0 6.74756L25.1159 22.1398L17.9229 22.1486H17.9231Z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6543 30.9999L14.4146 24.2851L17.9235 22.1487L25.1163 22.1399L10.6543 30.9999Z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00488281 24.2477L10.6826 17.7067L7.09277 15.5042L3.75459 17.5507L0.00488281 24.2477Z",
    fill: "#984995"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSbpLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sbp-logo.4bd43778.svg";
export { ForwardRef as ReactComponent };